import React from 'react';
import { useTranslation } from 'react-i18next';

export default function FamilyHeaderStats({ members = [] }) {
  const { t } = useTranslation();
  const size = members.length;
  const withEmail = members.filter((m) => Boolean(m.email)).length;
  const withPhone = members.filter((m) => Boolean(m.phone)).length;
  return (
    <div className="grid grid-cols-3 gap-4">
      <StatCard label={t('advisorPortal.familyMembersCount')} value={size} icon="ri-team-line" />
      <StatCard label={t('advisorPortal.familyWithEmail')} value={withEmail} icon="ri-mail-line" />
      <StatCard label={t('advisorPortal.familyWithMobile')} value={withPhone} icon="ri-smartphone-line" />
    </div>
  );
}

function StatCard({ label, value, icon }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4">
      <div className="flex items-center gap-2 mb-1.5">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className={`${icon} text-slate-400 text-sm`} />
        </div>
        <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">{label}</p>
      </div>
      <p className="text-2xl font-bold text-slate-900">{value}</p>
    </div>
  );
}

